import ColorPicker from 'lib/ui/ColorPicker'
import React from 'react'
import {Controller} from 'react-hook-form'
import {useConfig} from 'organization/Event/Configurable'
import {AgendaSectionProps} from 'Event/template/Townhall/Dashboard/Main/AgendaSection'
import CollapsibleSection from 'lib/ui/ConfigPanel/CollapsibleSection'
import Label from 'lib/ui/TextField/Label'
import FontSelect from 'lib/FontSelect'
import BackgroundPicker from 'lib/ui/form/BackgroundPicker'
import {useTownhallTemplate} from 'Event/template/Townhall'

export default function Styling(props: {
  agendaSection: AgendaSectionProps
  sectionId: string
}) {
  const {agendaSection, sectionId} = props
  const {
    form: {control},
  } = useConfig()
  const template = useTownhallTemplate()
  const {textColor} = template
  const agendaColor = agendaSection.color ? agendaSection.color : textColor

  return (
    <>
      <CollapsibleSection
        label="Background"
        storageKey="dashboard.blogSection.styling"
      >
        <Controller
          name={`dashboardSections.${sectionId}.background`}
          control={control}
          defaultValue={agendaSection.background}
          render={({onChange, value}) => (
            <BackgroundPicker
              hasFreeSize
              label="Background Color"
              background={value}
              onChange={onChange}
            />
          )}
        />
      </CollapsibleSection>
      <CollapsibleSection
        label="Typography"
        storageKey="dashboard.agendaSection.text.styling"
      >
        <Label>Font</Label>
        <Controller
          control={control}
          name={`dashboardSections.${sectionId}.font`}
          defaultValue={agendaSection.font || null}
          render={({value, onChange}) => (
            <FontSelect value={value} onChange={onChange} />
          )}
        />
        <Controller
          name={`dashboardSections.${sectionId}.color`}
          control={control}
          defaultValue={agendaColor}
          render={({value, onChange}) => (
            <ColorPicker
              label="Font Color"
              aria-label="font color"
              color={value}
              onPick={onChange}
            />
          )}
        />
      </CollapsibleSection>
      <CollapsibleSection
        label="Separator"
        storageKey="dashboard.agendaSection.separator.styling"
      >
        <Controller
          name={`dashboardSections.${sectionId}.separator.color`}
          control={control}
          defaultValue={agendaSection.separator?.color || '#ffffff'}
          render={({value, onChange}) => (
            <ColorPicker
              label="Color"
              aria-label="separator color"
              color={value}
              onPick={onChange}
            />
          )}
        />
      </CollapsibleSection>
    </>
  )
}
